import React, { useEffect, useMemo, useState } from "react";

import { resolveUserPhotoUrl } from "../../utils/userAvatar";

export default function UserAvatar({
   person = null,
   color,
   initials = "–",
   className = "studentItem__avatar",
   textClassName = "",
   style = {},
   alt = "",
}) {
   const photoUrl = useMemo(() => resolveUserPhotoUrl(person), [person]);
   const [failed, setFailed] = useState(false);

   useEffect(() => {
      setFailed(false);
   }, [photoUrl]);

   const showPhoto = Boolean(photoUrl) && !failed;

   return (
      <div
         className={className}
         aria-hidden={alt ? undefined : true}
         style={{
            background: color,
            color: "var(--black-p)",
            ...style,
         }}
      >
         {showPhoto ? (
            <img
               className="userAvatar__photo"
               src={photoUrl}
               alt={alt}
               loading="lazy"
               decoding="async"
               referrerPolicy="no-referrer"
               onError={() => setFailed(true)}
            />
         ) : (
            <span className={textClassName}>{initials}</span>
         )}
      </div>
   );
}
